import { Stack, Typography } from '@mui/material';
import React from 'react';

import { TJobIdLabelProps } from '@/console/features/jobs/components/job-id-label/job-id-label.types';
import { usePipelineStepType } from '@/console/features/pipelines/hooks/use-pipeline-step-type/use-pipeline-step-type';
import { Tooltip } from '@/shared/components/ui/tooltip/tooltip';
import { getRestoreJobBaseFeature } from '@/shared/features/jobs/jobs.utils';
import { formatShortId } from '@/shared/utils/format';

export const JobIdLabel: React.FC<TJobIdLabelProps> = ({
  jobType,
  jobId,
  variant = 'default',
}) => {
  const { getStepTypeIcon } = usePipelineStepType();
  const _jobType =
    variant === 'restore' ? getRestoreJobBaseFeature(jobType) : jobType;

  return (
    <Tooltip title={jobId}>
      <Stack
        component="span"
        direction="row"
        alignItems="center"
        gap="0.375rem"
      >
        {getStepTypeIcon(_jobType, { size: '1rem', variant: 'primary' })}
        <Typography variant="p8">{formatShortId(jobId)}</Typography>
      </Stack>
    </Tooltip>
  );
};
